import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../panel/userPanel.css";
import api from "../../utils/api";

export default function UploadSong() {
  const navigate = useNavigate();
  const audioRef = useRef(null);

  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const userId = user?._id;

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    lyrics: "",
    category: "",
  });

  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");

  const [genres, setGenres] = useState([]); 

  const [audioFile, setAudioFile] = useState(null);
  const [thumbnailFile, setThumbnailFile] = useState(null);

  const [audioPreview, setAudioPreview] = useState(null);
  const [thumbPreview, setThumbPreview] = useState(null);

  const [duration, setDuration] = useState(0);
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);

  /* ================= CLEANUP PREVIEW ================= */
  useEffect(() => {
    return () => {
      if (audioPreview) URL.revokeObjectURL(audioPreview);
      if (thumbPreview) URL.revokeObjectURL(thumbPreview);
    };
  }, [audioPreview, thumbPreview]);


   useEffect(() => {
  api.get("/client/song/getGenres").then(res => {
    if (res.data.status) {
      setGenres(res.data.genres);
      // Pehla genre automatically select ho jaye
      if(res.data.genres.length > 0) setFormData(p => ({...p, category: res.data.genres[0]}));
    }
  });
}, []);

  /* ================= AUDIO SELECT ================= */
  const handleAudioSelect = (file) => {
    if (!file) return;

    setAudioFile(file);

    const url = URL.createObjectURL(file);
    setAudioPreview(url);

    const audio = new Audio(url);
    audio.addEventListener("loadedmetadata", () => {
      setDuration(Math.floor(audio.duration));
    });
  };

  /* ================= THUMB SELECT ================= */
  const handleThumbSelect = (file) => {
    if (!file) return;
    setThumbnailFile(file);
    setThumbPreview(URL.createObjectURL(file));
  };

  /* ================= TAG ADD ================= */
  const addTag = () => {
    const value = tagInput.trim();
    if (!value) return;
    if (tags.includes(value)) return;

    setTags([...tags, value]);
    setTagInput("");
  };

  const removeTag = (tag) => {
    setTags(tags.filter((t) => t !== tag));
  };

  /* ================= UPLOAD ================= */
  const handleUpload = async () => {
    if (!formData.title.trim()) {
      alert("Title required");
      return;
    }

     if (!formData.category) {
     alert("Please select a valid category/genre");
     return;
   }

    if (!audioFile) {
      alert("Audio file required");
      return;
    }

     if (!acceptTerms) {
       alert("You must accept the Terms & Conditions");
       return;
     }

    if (!userId) {
      alert("Login required");
      return;
    }

    setUploading(true);

    const form = new FormData();

    // ?? IMPORTANT for middleware detection
    form.append("folderStructure", "Songs");

    form.append("userId", userId);
    form.append("title", formData.title);
    form.append("description", formData.description);
    form.append("lyrics", formData.lyrics);
    form.append("category", formData.category);
    form.append("duration", duration);
    form.append("tags", tags.join(","));
    form.append("acceptTerms", acceptTerms);

    form.append("audio", audioFile);

    if (thumbnailFile) {
      form.append("thumbnail", thumbnailFile);
    }

    try {
      const res = await api.post("/client/song/uploadSong", form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (event) => {
          if (!event.total) return;
          const percent = Math.round(
            (event.loaded * 100) / event.total
          );
          setProgress(percent);
        },
      });

      if (res.data.status) {
        alert("Song uploaded successfully");
        navigate("/user/content");
      } else {
        alert(res.data.message);
      }

    } catch (err) {
      console.error("Upload error:", err);
      alert("Upload failed");
    } finally {
      setUploading(false);
      setProgress(0);
    }
  };

  return (
    <div className="upload-container">
  <div className="upload-card">
      <h2>Upload Song</h2>

      {/* TITLE */}
      <div className="form-group">
        <label>Title *</label>
        <input
         className="form-input"
          value={formData.title}
          onChange={(e) =>
            setFormData({ ...formData, title: e.target.value })
          }
        />
      </div>

      {/* DESCRIPTION */}
      <div className="form-group">
        <label>Description</label>
        <textarea
         className="form-textarea"
          value={formData.description}
          onChange={(e) =>
            setFormData({
              ...formData,
              description: e.target.value,
            })
          }
        />
      </div>

      {/* LYRICS */}
      <div className="form-group">
        <label>Lyrics</label>
        <textarea
        className="form-textarea"
          rows={6}
          value={formData.lyrics}
          onChange={(e) =>
            setFormData({
              ...formData,
              lyrics: e.target.value,
            })
          }
        />
      </div>

      {/* CATEGORY DROPDOWN */}
    <div className="form-group">
    <label>Category *</label>
     <select
    className="form-input"
    style={{ 
      width: "100%", 
      padding: "10px", 
      background: "white", 
      color: "black",
      borderRadius: "4px",
      border: "1px solid #ccc" 
    }}
    value={formData.category}
    onChange={(e) => setFormData({ ...formData, category: e.target.value })}
  >
    {genres.length > 0 ? (
      genres.map((g) => (
        <option key={g} value={g}>
          {g}
        </option>
      ))
    ) : (
      <option value="general">Loading Genres...</option>
    )}
  </select>
</div>


      {/* TAGS */}
      <div className="form-group">
        <label>Tags</label>
        <div style={{ display: "flex", gap: "10px" }}>
          <input
           className="form-input"
            value={tagInput}
            onChange={(e) => setTagInput(e.target.value)}
          />
          <button type="button" className="upload-btn" onClick={addTag}>
            Add
          </button>
        </div>

        <div style={{ marginTop: "10px" }}>
          {tags.map((tag) => (
            <span
              key={tag}
              style={{
                padding: "5px 10px",
                background: "#eee",
                marginRight: "5px",
                borderRadius: "20px",
                cursor: "pointer",
              }}
              onClick={() => removeTag(tag)}
            >
              {tag} �
            </span>
          ))}
        </div>
      </div>

      {/* AUDIO */}
      <div className="form-group">
        <label>Audio *</label>
        <input
         className="form-input"
          type="file"
          accept="audio/*"
          onChange={(e) =>
            handleAudioSelect(e.target.files[0])
          }
        />
      </div>

      {audioPreview && (
        <audio
          ref={audioRef}
          controls
          src={audioPreview}
          style={{ width: "100%", marginTop: "10px" }}
        />
      )}

      {duration > 0 && (
        <p>Detected Duration: {duration}s</p>
      )}

      {/* THUMBNAIL */}
      <div className="form-group">
        <label>Thumbnail</label>
        <input
         className="form-input"
          type="file"
          accept="image/*"
          onChange={(e) =>
            handleThumbSelect(e.target.files[0])
          }
        />
      </div>

      {thumbPreview && (
        <img
          src={thumbPreview}
          alt="preview"
          style={{
            width: "200px",
            borderRadius: "8px",
            marginTop: "10px",
          }}
        />
      )}


    {/* TERMS AGREEMENT */}
<div
  style={{
    marginTop: "20px",
    padding: "10px",
    border: "1px solid #eee",
    borderRadius: "8px",
  }}
>
  <label style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
    <input
      type="checkbox"
      checked={acceptTerms}
      onChange={(e) => setAcceptTerms(e.target.checked)}
      style={{ marginTop: "4px" }}
    />

    <span style={{ fontSize: "14px" }}>
      I confirm that the audio I am uploading is my original content or I
      have the legal rights to upload it. I agree to the{" "}
      <a 
        href="/terms-and-conditions.html"
        target="_blank"
        rel="noopener noreferrer"
        style={{color:"#ff1f4b", fontWeight:"600"}}
        >
        Terms & Conditions
      </a>.
    </span>
  </label>
</div>

      {/* PROGRESS BAR */}
      {uploading && (
        <div style={{ marginTop: "15px" }}>
          <div
            style={{
              height: "8px",
              background: "#eee",
              borderRadius: "5px",
            }}
          >
            <div
              style={{
                width: `${progress}%`,
                height: "100%",
                background: "#ff1f4b",
                borderRadius: "5px",
                transition: "width 0.3s ease",
              }}
            />
          </div>
          <p>{progress}% uploading...</p>
        </div>
      )}

      <button
        className="upload-btn"
        disabled={uploading || !acceptTerms}
        onClick={handleUpload}
      >
        {uploading ? "Uploading..." : "Upload Song"}
      </button>
    </div>

</div>
);
}